export default {
  placeholder: 'Introduza o nome do restaurante',
  labels: {
    cant_find_place: 'Não encontra o lugar na lista?',
    reset_categories: 'Repor categorias de lugar',
  },
};
